import { createSlice } from '@reduxjs/toolkit';

export type OrderSummaryState = {
  data: {
    creditValue: number | null;
  };
};

export const initialState: OrderSummaryState = {
  data: {
    creditValue: null
  }
};

export const slice = createSlice({
  name: 'orderSummary',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setCreditValue: (state, { payload }) => {
      state.data.creditValue = payload;
    }
  }
});

export const { setInitialState, setCreditValue } = slice.actions;
export const selectSlice = (state) => state[slice.name];
export const selectData = (state) => selectSlice(state).data;
export const selectCreditValue = (state) => selectData(state).creditValue;

export default slice.reducer;
